export function getErrorByPath<T = unknown>(
  errors: unknown,
  path: unknown
): T | undefined {
  if (typeof path === 'string') {
    return path.split('.').reduce<unknown>((acc, key) => {
      if (acc == null) return undefined
      return acc[key as keyof typeof acc]
    }, errors) as T | undefined
  }
  return undefined
}
